import React from 'react';

/**
 * Sk — the skeleton primitive. Renders a single shimmer block.
 *
 * @param {string|number} [w]  - width as px number or CSS string (e.g. '60%', '100px').
 *                               For Tailwind-based widths pass via className instead.
 * @param {string|number} [h]  - height as px number or CSS string.
 * @param {string} [r]         - Tailwind border-radius class (default: 'rounded').
 * @param {string} [className] - additional Tailwind classes (e.g. responsive widths).
 */
export const Sk = ({ w, h, r = 'rounded', className = '' }) => (
  <div
    className={`skeleton ${r} ${className}`}
    style={{
      width:  w != null ? (typeof w === 'number' ? `${w}px` : w) : undefined,
      height: h != null ? (typeof h === 'number' ? `${h}px` : h) : undefined,
    }}
  />
);

/** Single text-line skeleton (14px tall). */
export const SkLine = ({ w = '100%', className = '' }) => (
  <Sk w={w} h={14} className={className} />
);

/** Circle skeleton (avatar, icon placeholder). */
export const SkCircle = ({ size = 40, className = '' }) => (
  <Sk w={size} h={size} r="rounded-full" className={`shrink-0 ${className}`} />
);
